import { createFileRoute } from '@tanstack/react-router';

import { HomeError } from './-components/error/HomeError';
import { Home } from './-components/Home';
import { useHome } from './-logic/useHome';
import { HomeContext } from './-logic/useHomeContext';

export const Route = createFileRoute('/_authed/home/')({
  component: HomePage,
  errorComponent: HomeError,
});

function HomePage() {
  return (
    <HomeContext.Provider value={useHome()}>
      <Home />
    </HomeContext.Provider>
  );
}
